module.exports = __webpack_public_path__ + "static/media/applewatch-black-circle.6fb89af2.svg";